exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ServerGroupParameters .StandardFieldLayout_Label {\n  min-width: 160px;\n}\n", ""]);

